export const EXPRESS_HOME_DELIVERY = 'EXPRESS_HOME_DELIVERY';
export const EXPRESS_RELAY_POINT = 'EXPRESS_RELAY_POINT';
export const HOME_DELIVERY = 'HOME_DELIVERY';
export const HOME_DELIVERY_EXPRESS = 'HOME_DELIVERY_EXPRESS';
export const HOME_FLOOR_DELIVERY_EXPRESS = 'HOME_FLOOR_DELIVERY_EXPRESS';
export const PRE_ORDER_SCHEDULED_DELIVERY_AT_STREET =
  'PRE_ORDER_SCHEDULED_DELIVERY_AT_STREET';
export const PRE_ORDER_SCHEDULED_DELIVERY_ROOM_OF_CHOICE =
  'PRE_ORDER_SCHEDULED_DELIVERY_ROOM_OF_CHOICE';
export const RELAY_POINT = 'RELAY_POINT';
export const RELAY_POINT_EXPRESS = 'RELAY_POINT_EXPRESS';
export const ROOM_OF_CHOICE = 'ROOM_OF_CHOICE';
export const HOME_EXPRESS = 'HOME_EXPRESS';
export const H24 = '24h';
export const H48 = '48h';
export type DeliveryExpressMode = typeof H24 | typeof H48 | null;

export const EXPRESS_DELIVERY_MODES = [
  EXPRESS_HOME_DELIVERY,
  EXPRESS_RELAY_POINT,
  HOME_DELIVERY_EXPRESS,
  HOME_FLOOR_DELIVERY_EXPRESS,
  RELAY_POINT_EXPRESS,
];

export type DeliveryMode =
  | typeof EXPRESS_HOME_DELIVERY
  | typeof EXPRESS_RELAY_POINT
  | typeof HOME_DELIVERY
  | typeof HOME_DELIVERY_EXPRESS
  | typeof PRE_ORDER_SCHEDULED_DELIVERY_AT_STREET
  | typeof PRE_ORDER_SCHEDULED_DELIVERY_ROOM_OF_CHOICE
  | typeof RELAY_POINT
  | typeof RELAY_POINT_EXPRESS
  | typeof ROOM_OF_CHOICE;
